module.exports = __webpack_public_path__ + "static/media/logo-sm.a915b62a.png";